/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

import { MrfiktivHttpClientProvider } from "../../mrfiktiv-http-client.provider";
import {
  MrfiktivFleetContractControllerGetAllParamsGen,
  MrfiktivMultipleIdsDtoOptionalGen
} from "../../v1/data-contracts";
import { FleetContracts } from "../../v1/FleetContracts";

export class ContractFleetService {
  /**
   * The proxy.
   */
  proxy: FleetContracts;

  /**
   * @class Initialize ContractFleetService
   */
  constructor(clientProvider: MrfiktivHttpClientProvider) {
    this.proxy = new FleetContracts(clientProvider.client());
  }

  async findAll(query: MrfiktivFleetContractControllerGetAllParamsGen, data: MrfiktivMultipleIdsDtoOptionalGen) {
    return (await this.proxy.fleetContractControllerGetAllPost(query, data)).data;
  }

  findOne(partnerId: string, fleetId: string, id: string) {
    return this.proxy.fleetContractControllerGetOne(partnerId, fleetId, id);
  }
}

export default new ContractFleetService(new MrfiktivHttpClientProvider());
